import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/icon/person_icon.png")